// removed by extract-text-webpack-plugin
module.exports = {"suggestionsContainer":"styles__suggestionsContainer___A0luc","suggestionsContainerOpen":"styles__suggestionsContainerOpen___3n3Gx","suggestionsList":"styles__suggestionsList___3Z3H6","suggestion":"styles__suggestion___1w5o3","input":"styles__input___2Hqup"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutoSuggest/MaterialAutoSuggest/styles.scss
// module id = 7029
// module chunks = 0